import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import NotificationsPanelFull from './NotificationsPanelFull';
import NotificationsPanelNarrow from './NotificationsPanelNarrow';

const NotificationsPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: NotificationsPanelFull, narrow: NotificationsPanelNarrow }}
    onChange={onChange}
  />
);

export default NotificationsPanel;
